module.exports = __webpack_public_path__ + "img/7.19c831d7.png";